module.exports = __webpack_public_path__ + "static/media/3d-base.c10526cc.svg";